export const holiday = 'Urlaub';
export const sickleave = 'arbeitsunfähig';